import { c as _c } from "react/compiler-runtime";
import type { Entry } from "contentful";
import { isEntry } from "@/lib/contentful/guards";
import type { TypeValuePropSkeleton } from "@/types/contentful/generated";
import { ValuePropItem } from "./ValuePropItem";
export type ValuePropEntry = Entry<TypeValuePropSkeleton, undefined, string>;
interface Props {
  items: ValuePropEntry[];
}
export default function ValuePropsCard(t0) {
  const $ = _c(11);
  const {
    items
  } = t0;
  let t1;
  let t2;
  let t3;
  let t4;
  if ($[0] !== items) {
    t4 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const valueProps = items.filter(isEntry);
      if (valueProps.length === 0) {
        t4 = null;
        break bb0;
      }
      t3 = "flex flex-col gap-6 py-6 w-full max-w-site-content mx-auto px-6";
      t1 = "flex flex-col rounded-lg bg-card p-6 gap-6 shadow-md md:flex-row md:py-16 md:items-start";
      t2 = valueProps.map(_temp);
    }
    $[0] = items;
    $[1] = t1;
    $[2] = t2;
    $[3] = t3;
    $[4] = t4;
  } else {
    t1 = $[1];
    t2 = $[2];
    t3 = $[3];
    t4 = $[4];
  }
  if (t4 !== Symbol.for("react.early_return_sentinel")) {
    return t4;
  }
  let t5;
  if ($[5] !== t1 || $[6] !== t2) {
    t5 = <div className={t1}>{t2}</div>;
    $[5] = t1;
    $[6] = t2;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t3 || $[9] !== t5) {
    t6 = <section className={t3}>{t5}</section>;
    $[8] = t3;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  return t6;
}
function _temp(item) {
  return <ValuePropItem key={item.sys.id} item={item} />;
}